.fg{z-index:2;}